import { snakeCase } from 'lodash'
import Api from '../Api'

const users = {
  namespaced: true,
  state: {
    users: [],
    count: 0,
    loading: false,
    page: 1,
    order: null,
    asc: null,
    plan: null,
    search: null,
    active: false
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    setMetadata(state, { page, order, asc, plan, search, active }) {
      state.page = (order || asc) ? 1 : (page || state.page)
      if(order) state.order = order
      if(asc) state.asc = asc
      state.plan = plan
      state.search = search
      state.active = active
    },
    receive(state, data) {
      state.users = data.users
      state.count = data.resultCount
      state.loading = false
    },
    unshift(state, user) {
      state.users.unshift(user)
      state.count = state.count + 1
    },
    replace(state, user) {
      const users = state.users
      const existingUserIdx = users.findIndex(u => u.id === user.id)
      users[existingUserIdx] = user
      state.users = [...users]
    }
  },
  actions: {
    async fetchPage({ commit, state: { page, order, asc, plan, search, active } }, metadata = {}) {
      metadata = { page, order, asc, plan, search, active, ...metadata }

      commit('startLoading')
      commit('setMetadata', metadata)

      const { data } = await Api.get('/guestroom/users', {
        params: {
          ...metadata,
          order: snakeCase(metadata.order)
        }
      })
      commit('receive', data)
    },
  }
}

export default users